import { Injectable, Injector } from '@angular/core';

import { Observable } from 'rxjs';
import { BaseService } from '../base/base.service';
import { Document } from '../../models/document/document';
import { Query } from '../../models/query/query';
import { Criterion } from '../../models/query/criterion';
import { WebMethodResult } from '../../models/web-method-result';
import { AppModulePath } from '../../models/app-module-path';
import { DocumentItem } from '../../models/document/document-item';
import { DocumentItemSerial } from '../../models/document/document-item-serial';
import { Item } from '../../models/lookups/item';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { PlatformLocation } from '@angular/common';
import { catchError, map } from 'rxjs/operators';
import { inject } from '@angular/core/testing';
import { DocumentPartijaSpecifikacija } from '../../models/document/document-partija-specifikacija';

@Injectable()
export class DocumentService extends BaseService {

  private listUrl = '/api/document/list';
  private listLimitUrl = '/api/document/listLimit';
  private listLimitSpecUrl = '/api/document/listLimitSpec';
  private saveUrl = '/api/document/save';
  private saveAggregateUrl = '/api/document/saveAggregate';
  private deleteUrl = 'api/document/delete/';
  private closeUrl = 'api/document/close';
  private changeStatusUrl = 'api/document/changeStatus';
  private updateStatusUrl = '/api/document/markAsStorno'
  private reversalUrl = 'api/document/reversal';
  private countUrl = 'api/document/countDocuments';
  private countDocUrl = 'api/document/countDoc';
  private pocetnoStanjeUrl = '/api/document/pocetnoStanje';
  private docByNumber = 'api/document/docByNumber/';
  private listDocZaPovracajUrl = '/api/document/listDocZaPovracaj';

  private createInvFormSitUrl = '/api/document/createInvFromSituation/{id}';

  private importInterniPrijemIzdavanjeUrl = '/api/document/importInterniPrijemIzdavanje';
  private exportInterniPrijemIzdavanjeUrl = '/api/document/exportInterniPrijemIzdavanje/{id}/{format}';

  constructor(protected injector: Injector,
    protected http2: HttpClient,
    protected platformLocation: PlatformLocation) {
    super(injector, http2, platformLocation);
  }

  documnetByNumber(docNumber): Observable<Document> {
    return this.get<Document>(this.docByNumber + docNumber, AppModulePath.DOCUMENT).pipe(
      map(this.extractData),
      catchError(this.handleError));
  }

  list(qry: Query): Observable<Document[]> {
    const url = this.listUrl + '?q=' + encodeURIComponent(JSON.stringify(qry));
    return this.get<Document[]>(url, AppModulePath.DOCUMENT).pipe(
      map(this.extractData),
      catchError(this.handleError));
  }

  listDocZaPovracaj(qry: Query): Observable<Document[]> {
    const url = this.listDocZaPovracajUrl + '?q=' + encodeURIComponent(JSON.stringify(qry));
    return this.get<Document[]>(url, AppModulePath.DOCUMENT).pipe(
      map(this.extractData),
      catchError(this.handleError));
  }

  pocetnoStanje(): Observable<any> {
    return this.post<any>(this.pocetnoStanjeUrl, AppModulePath.DOCUMENT, null).pipe(
      catchError(this.handleError));
  }

  listLimit(qry: Query): Observable<Document[]> {
    const url = this.listLimitUrl + '?q=' + encodeURIComponent(JSON.stringify(qry));
    return this.get<Document[]>(url, AppModulePath.DOCUMENT).pipe(
      map(this.extractData),
      catchError(this.handleError));
  }


  listLimitSpec(qry: Query): Observable<Document[]> {
    const url = this.listLimitSpecUrl + '?q=' + encodeURIComponent(JSON.stringify(qry));
    return this.get<Document[]>(url, AppModulePath.DOCUMENT).pipe(
      map(this.extractData),
      catchError(this.handleError));
  }

  count(qry: Query): Observable<number> {
    const url = this.countUrl + '?q=' + encodeURIComponent(JSON.stringify(qry));
    return this.get<number>(url, AppModulePath.DOCUMENT).pipe(
      map(res => res),
      catchError(this.handleError));
  }

  // sa alias doc
  countDoc(qry: Query): Observable<number> {
    const url = this.countDocUrl + '?q=' + encodeURIComponent(JSON.stringify(qry));
    return this.get<number>(url, AppModulePath.DOCUMENT).pipe(
      map(res => res),
      catchError(this.handleError));
  }

  save(document: Document): Observable<Document> {
    return this.post<Document>(this.saveUrl, AppModulePath.DOCUMENT, document).pipe(
      map(this.extractData),
      catchError(this.handleError));
  }

  saveAggregate(payload: any): Observable<Document> {
    return this.post<Document>(this.saveAggregateUrl,AppModulePath.DOCUMENT,payload
  ).pipe(
      map(this.extractData),
      catchError(this.handleError)
  );

}

  saveRashodManjakOS(tip: number): Observable<Document> {
    return this.post<Document>(this.saveUrl + '/' + tip, AppModulePath.DOCUMENT, tip).pipe(
      map(this.extractData),
      catchError(this.handleError));
  }

  delete(id: string): Observable<WebMethodResult> {
    return this._delete<WebMethodResult>(this.deleteUrl + id, AppModulePath.DOCUMENT).pipe(
      map(res => new WebMethodResult(res)),
      catchError(this.handleError));
  }

  closeDocument(id: string): Observable<WebMethodResult> {
    return this.post<WebMethodResult>(this.closeUrl, AppModulePath.DOCUMENT, id).pipe(
      map(res => new WebMethodResult(res)),
      catchError(this.handleError));
  }

  changeStatus(document: Document): Observable<WebMethodResult> {
    return this.post<WebMethodResult>(this.changeStatusUrl, AppModulePath.DOCUMENT, document).pipe(
      map(res => new WebMethodResult(res)),
      //     .map(( res: HttpResponse<any> ) =>  new Document( res.body() ) )
      //     .map(this.extractData)
      catchError(this.handleError));
  }

  updateStatus(document: Document): Observable<WebMethodResult> {
  return this.post<WebMethodResult>(this.updateStatusUrl, AppModulePath.DOCUMENT, document).pipe(
      map(res => new WebMethodResult(res)),
      catchError(this.handleError));
}

  documentReversal(document: Document): Observable<WebMethodResult> {
    return this.post<WebMethodResult>(this.reversalUrl, AppModulePath.DOCUMENT, document).pipe(
      map(res => new WebMethodResult(res)),
      catchError(this.handleError));
  }

  extractData(res: any): any {
    if (res && res.document) {
     res = res.document;
  }

    const data = res || [];
    if (data instanceof Array) {
      return data.map((d: Document) => {
        d = new Document(d);
        d.documentDate = d.documentDate ? new Date(d.documentDate) : null;
        d.externalDate = d.externalDate ? new Date(d.externalDate) : null;
        d.date = d.date ? new Date(d.date) : null;
        d.dateVat = d.dateVat ? new Date(d.dateVat) : null;
        d.updatedAt = d.updatedAt ? new Date(d.updatedAt) : null;
        d.createdAt = d.createdAt ? new Date(d.createdAt) : null;
        d.deletedAt = d.deletedAt ? new Date(d.deletedAt) : null;

        d.documentItems = d.documentItems.map((di: DocumentItem) => {
          di = new DocumentItem(di);
          if (di.item) {
            di.item = new Item(di.item);
          }
          if (di.serialNumbers != null) {
            di.serialNumbers = di.serialNumbers.map(serial => {
              return new DocumentItemSerial(serial);
            });
          }
          return di;
        });
        d.documentPS = d.documentPS.map((di: DocumentPartijaSpecifikacija) => {
          di = new DocumentPartijaSpecifikacija(di);
          if (di.item) {
            di.item = new Item(di.item);
          }
          return di;
        });
        return d;
      });
    } else {
      const doc = new Document(data);
     doc.documentDate = data.documentDate ? new Date(data.documentDate) : null;
     doc.externalDate = data.externalDate ? new Date(data.externalDate) : null;
     doc.date = data.date ? new Date(data.date) : null;
     doc.dateVat = data.dateVat ? new Date(data.dateVat) : null;
     doc.updatedAt = data.updatedAt ? new Date(data.updatedAt) : null;
     doc.createdAt = data.createdAt ? new Date(data.createdAt) : null;
     doc.deletedAt = data.deletedAt ? new Date(data.deletedAt) : null;

      doc.documentItems = doc.documentItems.map((di: DocumentItem) => {
        di = new DocumentItem(di);
        if (di.item) {
          di.item = new Item(di.item);
        }
        if (di.serialNumbers != null) {
          di.serialNumbers = di.serialNumbers.map(serial => {
            return new DocumentItemSerial(serial);
          });
        }
        return di;
      });
      doc.documentPS = doc.documentPS.map((di: DocumentPartijaSpecifikacija) => {
        di = new DocumentPartijaSpecifikacija(di);
        if (di.item) {
          di.item = new Item(di.item);
        }
        return di;
      });
      return doc;
    }
  }

  export(documentType: string, id: string, showPrice: boolean, printSerial?: boolean): any {
    const qry = new Query();
    qry.and().and(Criterion.equal(Document.TABLENAME, Document.ID, id));

    return this.downloadFile('/api/document/export/' + documentType, AppModulePath.DOCUMENT, qry, showPrice, printSerial).pipe(
      map((res) => {
        return new Blob([res], { type: 'application/pdf' });
      }),
      catchError(this.handleError));
  }

  exportCSV(documentType: string, id: string | number): any {
    const qry = new Query();
    qry.and().and(Criterion.equal(Document.TABLENAME, Document.ID, id));

    return this.downloadFile('/api/document/export/' + documentType, AppModulePath.DOCUMENT, qry).pipe(
      map((res) => {
        return new Blob([res], { type: 'text/csv' });
      }),
      catchError(this.handleError));
  }

  exportIzvestaj(reportName: String, query: Query): any {
    return this.downloadFile('/api/document/export/' + reportName, AppModulePath.DOCUMENT, query).pipe(
      map((res) => {
        return new Blob([res], { type: 'application/pdf' });
      }),
      catchError(this.handleError));
  }

  exportPresek(reportName: String, query: Query): any {
    return this.downloadFile('/api/dps/report/' + reportName, AppModulePath.DOCUMENT, query).pipe(
      map((res) => {
        return new Blob([res], { type: 'application/pdf' });
      }),
      catchError(this.handleError));
  }

  exportDokaznica(reportName: String, query: Query): any {
    return this.downloadFile('/api/dps/report/' + reportName, AppModulePath.DOCUMENT, query).pipe(
      map((res) => {
        return new Blob([res], { type: 'application/pdf' });
      }),
      catchError(this.handleError));
  }

  exportFinansijskiPresek(reportName: String, query: Query): any {
    return this.downloadFile('/api/dps/report/' + reportName, AppModulePath.DOCUMENT, query).pipe(
      map((res) => {
        return new Blob([res], { type: 'application/pdf' });
      }),
      catchError(this.handleError));
  }

  createInvoiceFromSituation(situacijaId: string) {
    return this.http2.post<WebMethodResult>(this.createInvFormSitUrl.replace('{id}', situacijaId.toString()), null).pipe(
      map(res => new WebMethodResult(res)),
      catchError(this.handleError));
  }

  importInterniPrijemIzdavanje(documentId: string, file: File) {
    const fd: FormData = new FormData();
    fd.append('id', documentId);
    fd.append('file', file);
    return this.put<WebMethodResult>(this.importInterniPrijemIzdavanjeUrl, AppModulePath.JAVNE_NABAVKE, fd).pipe(
      map(res => res),
      catchError(this.handleError));
  }

  exportInterniPrijemIzdavanje(id: string, format: string) {
    return this.get<HttpResponse<Blob>>(this.exportInterniPrijemIzdavanjeUrl.replace('{id}', id)
      .replace('{format}', format), AppModulePath.JAVNE_NABAVKE,
      { observe: 'response', responseType: 'blob' }).pipe(
        map((res) => res.body),
        catchError(this.handleError));
  }

  updateDocumentItemContractId(documentId: string, itemId: string, contractId: string | null): Observable<WebMethodResult> {
    const params = contractId != null ? `?contractId=${contractId}` : '';
    return this.patch<WebMethodResult>(
      `/api/document/item/${documentId}/${itemId}/contract${params}`,
      AppModulePath.DOCUMENT,
      null
    ).pipe(
      map(res => res),
      catchError(this.handleError)
    );
  }
}
